import React from 'react';
import { CommonLabel as Label } from '@/components/ui/common-label';
import { Badge } from '@/components/ui/badge';
import { 
  User, 
  Mail, 
  Phone, 
  Calendar, 
  MapPin,
  BadgeCheck,
  Building,
  Hash,
  UserCircle
} from 'lucide-react';

const ProfileDetails = ({ 
  profileData
}) => {

  const getRoleBadgeVariant = (role) => {
    if (!role) return 'default';
    
    const roleLower = role.toLowerCase();
    if (roleLower.includes('admin')) return 'admin';
    if (roleLower.includes('transporter')) return 'transporter';
    if (roleLower.includes('distributor')) return 'distributor';
    if (roleLower.includes('retailer')) return 'retailer';
    return 'default';
  };

  const profileFields = [
    { 
      icon: <User className="h-4 w-4 text-muted-foreground" />, 
      label: "Full Name", 
      value: profileData.name 
    },
    { 
      icon: <Mail className="h-4 w-4 text-muted-foreground" />, 
      label: "Email Address", 
      value: profileData.email 
    },
    { 
      icon: <Phone className="h-4 w-4 text-muted-foreground" />, 
      label: "Phone Number", 
      value: profileData.phone 
    },
    { 
      icon: <BadgeCheck className="h-4 w-4 text-muted-foreground" />, 
      label: "Role", 
      value: (
        <Badge variant={getRoleBadgeVariant(profileData.role)} className="mt-1">
          {profileData.role || 'N/A'}
        </Badge>
      ),
      isBadge: true
    },
    { 
      icon: <MapPin className="h-4 w-4 text-muted-foreground" />, 
      label: "Location", 
      value: profileData.location 
    },
    { 
      icon: <Calendar className="h-4 w-4 text-muted-foreground" />, 
      label: "Join Date", 
      value: profileData.joinDate ? new Date(profileData.joinDate).toLocaleDateString() : 'N/A'
    }
  ];

  
  const roleLower = profileData.role?.toLowerCase();
  if (roleLower && (roleLower.includes('transporter') || roleLower.includes('distributor') || roleLower.includes('retailer'))) {
    if (profileData.companyName) {
      profileFields.splice(4, 0, {
        icon: <Building className="h-4 w-4 text-muted-foreground" />,
        label: "Company Name",
        value: profileData.companyName
      });
    }
    
    if (profileData.registrationNumber) {
      profileFields.splice(5, 0, {
        icon: <Hash className="h-4 w-4 text-muted-foreground" />,
        label: "Registration Number",
        value: profileData.registrationNumber
      });
    }
    
    if (profileData.contactPerson) {
      profileFields.splice(6, 0, {
        icon: <UserCircle className="h-4 w-4 text-muted-foreground" />,
        label: "Contact Person",
        value: profileData.contactPerson
      });
    }
    
    if (profileData.address) {
      profileFields.splice(7, 0, {
        icon: <MapPin className="h-4 w-4 text-muted-foreground" />,
        label: "Address",
        value: profileData.address
      });
    }
  }

  return (
    <div className="border border-border p-0.5 rounded-[16px] bg-card w-full transition-all transform" style={{boxShadow: '0px 2px 10px 0px hsl(var(--border) / 0.1)'}}>
      <div className="border border-border px-4 py-4 rounded-[16px] bg-background">
        <div className="flex justify-between items-center mb-6">
          <Label size="lg" weight="bold" className="text-foreground">Profile Information</Label>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {profileFields.map((field, index) => (
            <div key={index} className="border border-border rounded-[12px] bg-card/50 px-4 py-1">
              <div className="flex items-start gap-3">
                <div className="pt-1">
                  {field.icon}
                </div>
                <div className="flex-1">
                  <Label size="xs" weight="medium" className="text-muted-foreground uppercase tracking-wide">
                    {field.label}
                  </Label>
                  {field.isBadge ? (
                    <div className="block text-foreground">
                      {field.value}
                    </div>
                  ) : (
                    <Label size="base" weight="medium" className="block text-foreground">
                      {field.value || 'N/A'}
                    </Label>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;